import { motion } from "framer-motion";

export const Logo = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#1f7a6c" />
    <path d="M14 44 L24 22 L36 40 L48 18" fill="none" stroke="#e8fbf7" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="14" cy="44" r="5" fill="#e8fbf7" />
    <circle cx="24" cy="22" r="5" fill="#e8fbf7" />
    <circle cx="36" cy="40" r="6.5" fill="#f0a23b" />
    <circle cx="48" cy="18" r="5" fill="#e8fbf7" />
  </svg>
);

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.22em] text-[var(--teal)] ${className}`}>{children}</p>
);

export const SectionHead = ({ eyebrow, title, body, id }) => (
  <Reveal className="max-w-3xl">
    <Eyebrow>{eyebrow}</Eyebrow>
    <h2 id={id} className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.02]">{title}</h2>
    {body && <p className="mt-6 text-base md:text-lg text-[var(--muted)] leading-relaxed max-w-2xl">{body}</p>}
  </Reveal>
);
